module.exports = __webpack_public_path__ + "media/images/pc/stores/kyoto/kyoto_concept_01-eb1fe8c7c3c4421240f3b2d058501f4f.jpg";